<template>
    <rkm-overlay>
        <rkm-layout-body title="Recepção">
            <template v-slot:actions>
                <rkm-button
                    @click="handleInciarRecepcao"
                    authorize="store-pronto-atendimento-atendimento-recepcao"
                    color="primary"
                >
                    Iniciar recepção
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List @additionals="handleAdditionals">
                    <template v-slot:custom-actions="{ item }">
                        <rkm-button
                            @click="handleEdit(item)"
                            color="primary"
                            small
                            title="Atender"
                            authorize="store-pronto-atendimento-atendimento-recepcao"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/atendimento-recepcao/List'

// Mixins.
import { repository, error, data } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    mixins: [ repository, error, data ],
    components: { List },
    data: () => ({
        repositories: {
            dataHora: null,
            fila: null,
        },
        isPermissaoCadastro: null,
    }),
    created() {

        this.repositories.dataHora = this.getConectaSusRepository('dataHora')
        this.repositories.fila = this.getConectaSusRepository('prontoAtendimento.fila')
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleInciarRecepcao() {

            this.setLoading()

            this.repositories.dataHora.get()
                .then(({ data }) => this.$router.push({
                    name: 'pronto-atendimento-atendimento-recepcao-paciente',
                    params: { dataAtendimento: this.getDateTimeObject(data), isPermissaoCadastro: this.isPermissaoCadastro, }
                }))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEdit(item) {

            this.setLoading()

            this.repositories.dataHora.get()
                .then(({ data }) => {

                    const params = {
                        dataAtendimento: this.getDateTimeObject(data),
                        filaId: item.id,
                        plantaoId: item.currentPlantaoId,
                        isPermissaoCadastro: this.isPermissaoCadastro,
                    }

                    return this.repositories.fila.answer(item.id)
                        .then(() => {

                            if (item.atendimento.id) {

                                this.$router.push({
                                    name: 'pronto-atendimento-atendimento-recepcao-create',
                                    params: {
                                        ...params,
                                        pacienteId: item.atendimento.paciente.id
                                    }
                                })
                            }
                            else {

                                this.$router.push({
                                    name: 'pronto-atendimento-atendimento-recepcao-paciente',
                                    params
                                })
                            }
                        })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAdditionals(additionals) {

            this.isPermissaoCadastro = additionals.classificacoes.length > 0 || additionals.isPermissaoCadastro ? true : false
        }
    }
}
</script>